import React from 'react';
import '../style/Main.css';
import Login from '../in/Login';
import { useSEO } from '../../../hooks/useSEO';

const Main = () => {
  useSEO({
    title: 'Кіру — Agroland.kz',
    description: 'Agroland.kz жүйесіне кіру немесе тіркелу. Жеке кабинетке кіру үшін авторизациядан өтіңіз.',
    keywords: 'кіру, тіркелу, авторизация, логин, пароль',
    ogType: 'website',
    robots: 'noindex, nofollow' // Тіркелу бетін индекстеуге болмайды
  }, []);

  return (
    <Login />
  );
};

export default Main;